module.exports = __webpack_public_path__ + "static/img/done.275b519.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/done.png
// module id = GbBT
// module chunks = 1